import VueStore from "vue-j-store";

export default new VueStore({
    state:{
        redirect:null,
        direction:"forward",
        dirIndex:1,
        dirCache:{
            "/":0
        }
    },
    mutations:{
        login(state,userinfo){
           sessionStorage.setItem("userinfo",JSON.stringify(userinfo));
           state.userinfo=userinfo;
        },
        pushDirCache(state,path){
           state.dirCache[path]=state.dirIndex++;
        },
        pageTransition(state,type){
            state.direction=type;
        }
    }
});


// WEBPACK FOOTER //
// ./src/components/router-store.js